import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export const addFilesToServiceRequest = async (
  serviceRequestId: string,
  params: {
    outputFiles: FileBasic[];
  }
) => {
  const response = await fetcher(
    `${API_BASE_PATH}/${serviceRequestId}/files`,
    {
      method: 'POST',
      body: {
        outputFiles: params.outputFiles,
      },
    },
    undefined
  );

  if (!response.ok) {
    return { success: false };
  }
  const data = (await response.json()) as { fileIds: number[] };
  return { success: true, data };
};
